function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M73.653 1.62877H10.3468C5.74146 1.62877 2.00806 5.36217 2.00806 9.96756V48.8195C2.00806 53.4248 5.74146 57.1582 10.3468 57.1582H73.653C78.2583 57.1582 81.9917 53.4248 81.9917 48.8195V9.96756C81.9917 5.36217 78.2583 1.62877 73.653 1.62877Z",
  stroke: "black",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M59.8174 66.6526H24.1823C22.7679 66.6526 21.6213 67.7992 21.6213 69.2136V69.4947C21.6213 70.909 22.7679 72.0556 24.1823 72.0556H59.8174C61.2318 72.0556 62.3784 70.909 62.3784 69.4947V69.2136C62.3784 67.7992 61.2318 66.6526 59.8174 66.6526Z",
  stroke: "black",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M57.4438 66.6526H26.5559L27.8364 57.1582H56.1633L57.4438 66.6526Z",
  stroke: "black",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M32.0528 17.0259C32.0528 19.0247 30.4288 20.6487 28.43 20.6487C26.4312 20.6487 24.8071 19.0247 24.8071 17.0259",
  stroke: "black",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M57.4439 17.0259C57.4439 19.0247 55.8199 20.6487 53.8211 20.6487C51.8223 20.6487 50.1982 19.0247 50.1982 17.0259",
  stroke: "black",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M20.3098 43.4477C24.3387 35.9521 32.2402 30.8614 41.3598 30.8614C50.4794 30.8614 58.3185 35.9209 62.3473 43.354",
  stroke: "black",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
function SvgIcnSadMonitor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 84 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnSadMonitor);
export default __webpack_public_path__ + "static/media/icn-sad-monitor.ed09d2e8409e0be3ba2ef3d8b60f88ee.svg";
export { ForwardRef as ReactComponent };